module.exports = "https://r.zoocdn.com/_next/static/images/GlobalReachLogo-eaab954e5220c33c94000890b47b9e3d.jpg";